/** Text helpers for the 40-column screens. Pure. */

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

/** Word-wrap to lines of at most `width` characters; over-long words are cut. */
export function wrap(text: string, width: number): string[] {
  const lines: string[] = [];
  let line = '';
  for (const raw of text.split(/\s+/).filter((w) => w.length > 0)) {
    let word = raw;
    while (word.length > width) {
      if (line) {
        lines.push(line);
        line = '';
      }
      lines.push(word.slice(0, width));
      word = word.slice(width);
    }
    if (!word) continue;
    if (!line) line = word;
    else if (line.length + 1 + word.length <= width) line += ` ${word}`;
    else {
      lines.push(line);
      line = word;
    }
  }
  if (line) lines.push(line);
  return lines;
}

/** 9340 -> `9,340`. */
export function commas(n: number): string {
  const s = String(Math.max(0, Math.floor(n)));
  return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/** `23 SEP 2026`. */
export function longDate(year: number, month: number, day: number): string {
  return `${day} ${MONTHS[month - 1] ?? '???'} ${year}`;
}

/** `2026-09-23`, as the score tables store it. */
export function isoDate(year: number, month: number, day: number): string {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

/** A stored `2026-09-23` as `23 SEP 26`; anything else as it is. */
export function tableDate(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return iso.slice(0, 9);
  const [, y = '', mo = '', d = ''] = m;
  return `${d} ${MONTHS[Number(mo) - 1] ?? '???'} ${y.slice(2)}`;
}

/** Seconds as `71S`, or `2M 05S` from two minutes. */
export function seconds(s: number): string {
  const n = Math.max(0, Math.floor(s));
  if (n < 120) return `${n}S`;
  return `${Math.floor(n / 60)}M ${String(n % 60).padStart(2, '0')}S`;
}

/** Keep only what the 8 x 8 font can draw well: upper case, digits and its punctuation. */
export function printable(s: string): string {
  return s.toUpperCase().replace(/[^A-Z0-9 .,:;!?'"\-+/()%#*=<>&@[\]◆►◄▲▼©♥■·♪⌛✓_]/g, '?');
}
